<div style='padding: 20px'>
  <div fxLayout='row' fxLayout.xs='column' fxLayoutAlign='start center' fxLayoutAlign.xs='start stretch'>
    <div fxFlex>
      <p>{{ player.first }} {{player.last}}</p>
      <p *ngIf='playerIndex'>
        Revision Date:
        <b> {{ playerIndex.RevDate.replace(' ','T') | date:'shortDate'}}</b>
        <br />
        <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
          <span>
              Index:
          </span>
          <b *ngIf="playerIndex.Display">{{ playerIndex.Display}}</b>
          <b *ngIf="!playerIndex.Display" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <span>n/a</span>
            <i class="fa fa-question-circle" (click)="showHandicapPlusInfo()"></i>
          </b>
        </span>
      </p>
      <p fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="7px">
        <button style="width:150px" *ngIf='canPost' mat-raised-button color='primary' #adminMenuTrigger="matMenuTrigger"
          [matMenuTriggerFor]="addScoreMenu">
          Post a Score <mat-icon>keyboard_arrow_down</mat-icon>
        </button>
        <mat-menu #addScoreMenu="matMenu">
          <button mat-menu-item (click)='showPostDialog(false)'>Score Only</button>
          <button mat-menu-item (click)='showPostDialog(true)'>Hole-by-hole</button>
        </mat-menu>
        <button mat-raised-button color='accent' (click)='share()'>Share</button>
      </p>
      <div>
        <button mat-raised-button *ngIf="player.subscription_id" (click)="postRoundsToUsga()" style="width:150px">
          <div *ngIf="posting">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
          <div *ngIf="!posting">
            Sync with USGA
          </div>
        </button>
      </div>
    </div>
    <div style='height: 2.125in;position:relative' fxFlex>
      <!-- <s18-handicap-card [rounds]='handicap_rounds' [player]='player' [playerIndex]='playerIndex'>
      </s18-handicap-card> -->
    </div>
  </div>
  <mat-tab-group>
    <mat-tab label='Revision Rounds' *ngIf="handicap_rounds">
      <s18-display-round-list [rounds]='handicap_rounds.scores' [tRounds]='false' *ngIf='handicap_rounds'>
      </s18-display-round-list>
    </mat-tab>
    <mat-tab label='Revision History' *ngIf='handicap_history'>
      <div fxLayout='row' class='round-list-header'>
        <div fxFlex>Index</div>
        <div fxFlex>Revision Date</div>
      </div>
      <div *ngFor="let revision of handicap_history" fxLayout='row' class='round-list-item'>
        <div fxFlex>
          {{revision.Display}}
        </div>
        <div fxFlex>
          {{revision.RevDate.split(' ')[0] | date:'shortDate'}}
        </div>
      </div>
    </mat-tab>
    <mat-tab label='Last 25'>
      <s18-display-round-list [rounds]='last_25' [tRounds]='false' *ngIf='last_25 && last_25.length>0'>
      </s18-display-round-list>
    </mat-tab>
  </mat-tab-group>
</div>